import styled from 'styled-components'

export const ButtonsContainer = styled.div`
  padding-right: 8px;
`
